import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { getStoresAction } from "../../../../store/store/actions";
import { getSessionData } from "../../base/helper/baseHelper";
import {
  GetEmployeeDetails,
  GetStoreEmployeesEmail,
} from "../views/Helper/activeUserHelper";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  filed: {
    margin: "1vw",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  bg: {
    display: "flex",
    justifyContent: "flex-start",
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
}));

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

function AddUserBasics(props) {
  const classes = useStyles();
  const {
    addUserData,
    setAddUserData,
    userDataError,
    stores,
    getStores,
  } = props;
  const userId = getSessionData({ key: "userId" });
  const [value, setValue] = React.useState("Auto-generate Password");
  const [employeeData, setEmployeeData] = React.useState([]);

  React.useEffect(() => {
    if (userId && !stores.length) {
      getStores(userId);
    }
  }, [userId, stores, getStores]);

  const handleEmployeeChange = (event, value) => {
    setAddUserData({
      ...addUserData,
      selectemployee: value,
      firstname: "",
      lastname: "",
      emailid: "",
      userexists: false,
      employeeid: "",
      userpassword: "",
    });
    if (value && value.useremailid !== "") {
      GetEmployeeDetails(value.useremailid, value.storeid)
        .then((response) => {
          if (response && response.data && response.data.length > 0) {
            setAddUserData({
              ...addUserData,
              selectemployee: value,
              firstname: response.data[0].firstname,
              lastname: response.data[0].lastname,
              emailid: response.data[0].useremailid,
              userexists: true,
              employeeid: response.data[0].userid,
            });
          }
        })
        .catch((err) => {});
    }
  };
  const handleStoreChange = (event, value) => {
    setEmployeeData([]);
    setAddUserData({
      ...addUserData,
      selectstores: value,
      selectemployee: null,
      firstname: "",
      lastname: "",
      emailid: "",
      userexists: false,
      employeeid: "",
      createpasswordvalue: "",
    });
    if (value && value.length > 0) {
      var storeids = value
        .map((item) => {
          return item.storeid;
        })
        .join(",");
      GetStoreEmployeesEmail(storeids)
        .then((response) => {
          if (response && response.data && response.data.length > 0) {
            setEmployeeData(response.data);
          } else {
            setEmployeeData([]);
          }
        })
        .catch((err) => {
          setEmployeeData([]);
        });
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <h1 className={classes.bg}>Set up the basics</h1>
      <Container component="main" maxWidth="lg">
        <Grid container style={{ display: "flex", padding: "0" }}>
          <Grid item xs={8} className={classes.filed} style={{marginLeft: "15px"}}>
            <Autocomplete
              multiple
              value={addUserData.selectstores}
              onChange={handleStoreChange}
              options={
                stores && stores.length > 0
                  ? stores.filter((store) => store.adminflag === "1")
                  : []
              }
              getOptionLabel={(option) => {
                if (option && option.storename) {
                  return option.storename;
                } else {
                  return "";
                }
              }}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Pharmacy"
                  {...(userDataError.selectstores && {
                    error: true,
                    helperText: userDataError.selectstores,
                  })}
                />
              )}
            />
          </Grid>

          <Grid item xs={8} className={classes.filed} style={{marginLeft: "15px"}}>
            <Autocomplete
              value={addUserData.selectemployee}
              onChange={handleEmployeeChange}
              options={
                employeeData && employeeData.length > 0 ? employeeData : []
              }
              getOptionLabel={(option) => {
                if (option && option.useremailid) {
                  return option.useremailid;
                } else {
                  return "";
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Employee"
                  placeholder="Enter Email"
                />
              )}
            />
          </Grid>

          <Grid item xs={8} style={{marginLeft: "2px"}}>
            <TextField
              style={{ width: "100%" }}
              required
              disabled={
                addUserData.selectemployee &&
                addUserData.selectemployee.useremailid !== ""
                  ? true
                  : false
              }
              id="first-name"
              label="First Name"
              value={addUserData.firstname}
              onChange={props.inputchange}
              name="firstname"
              variant="outlined"
              className={classes.filed}
              {...(userDataError.firstname && {
                error: true,
                helperText: userDataError.firstname,
              })}
            />
          </Grid>
          <Grid item xs={8} style={{marginLeft: "2px"}}>
            <TextField
              style={{ width: "100%" }}
              disabled={
                addUserData.selectemployee &&
                addUserData.selectemployee.useremailid !== ""
                  ? true
                  : false
              }
              required
              label="Last Name"
              value={addUserData.lastname}
              onChange={props.inputchange}
              name="lastname"
              variant="outlined"
              className={classes.filed}
              {...(userDataError.lastname && {
                error: true,
                helperText: userDataError.lastname,
              })}
            />
          </Grid>

          <Grid item xs={8} style={{marginLeft: "2px"}}>
            <TextField
              style={{ width: "100%" }}
              disabled={
                addUserData.selectemployee &&
                addUserData.selectemployee.useremailid !== ""
                  ? true
                  : false
              }
              required
              label="Email ID"
              value={addUserData.emailid}
              onChange={props.inputchange}
              name="emailid"
              type="email"
              variant="outlined"
              className={classes.filed}
              {...(userDataError.emailid && {
                error: true,
                helperText: userDataError.emailid,
              })}
            />
          </Grid>
          <Grid item xs={12} className={classes.bg} style={{marginLeft: "20px"}}>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                <b>Password Settings</b>
              </FormLabel>
              <RadioGroup
                aria-label="Password"
                id="standard-password-input"
                name="Password"
                label="Password"
                type="password"
                autoComplete="current-password"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="Auto-generate Password"
                  style={{ display: "inline" }}
                  control={
                    <StyledRadio checked={addUserData.autogeneratepassword} />
                  }
                  onClick={() => {
                    props.inputpasswordchangetrue();
                  }}
                  label="Auto-generate Password"
                />
                <FormControlLabel
                  value="Let me create the Password"
                  control={
                    <StyledRadio checked={!addUserData.autogeneratepassword} />
                  }
                  onClick={() => {
                    props.inputpasswordchangefalse();
                  }}
                  label="Let me create the Password"
                />
                {!addUserData.autogeneratepassword && (
                  <TextField
                    required
                    id="outlined-password-input"
                    label="Password"
                    type="password"
                    value={addUserData.userpassword}
                    onChange={props.inputchange}
                    name="userpassword"
                    autoComplete="current-password"
                    variant="outlined"
                    {...(userDataError.userpassword && {
                      error: true,
                      helperText: userDataError.userpassword,
                    })}
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { stores: state.store };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (userId) => dispatch(getStoresAction(userId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUserBasics);
